import React, { Component } from 'react';
import service from '../../core/service';
import * as yup from 'yup'
import { fixNumbers } from '../../core/utils';

import { mobileNumberIranRegexp, nationalCodeRegexp } from '../../core/regexp';
import { toast } from 'react-toastify';
import { inqueryDataa } from '../../Redux/services/generalService';
import routes from '../../core/routes';
import axios from 'axios';
import { AppConstants } from '../../core/constants';
import Cookies from 'js-cookie';
import moment from 'moment-jalaali';
import { DateObject } from 'react-multi-date-picker';

interface IProps {
  inqueryData: any,
  userData: any,
  insuredEqualPolicyHolder: boolean
  dispatch?: any,
}
interface IState {
  str: string;
  value: string,
  value2: string,
  openBeneficiaryModal: boolean,
  startValue: string;
  open: any,
  anchorEl: null | HTMLElement;
  step: number;
  insuranceType: string;
  contentLoading: boolean;
  //
  contract_id: string;
  // 1
  step1Errors: any,
  policy_holder_national_code: string;
  insured_national_code: string;
  hasError: boolean,
  hasErrorMsg: string,
  inqueryRegisterOfficeData: any,
  inqueryRegisterOfficeData2: any,
  disease_policy_holder: any,
  public_policy_holder: any,
  disease_insured: any,
  public_insured: any;
  // 2
  policy_holder_is_married: string,
  policy_holder_mobile: string,
  policy_holder_postal_code: string;
  policy_holder_address: string,
  policy_holder_weight: string,
  policy_holder_height: string,
  policy_holder_city_id: string,
  policy_holder_soldier_status:string,


  insured_is_married: string,
  insured_mobile: string,
  insured_postal_code: string,
  insured_weight: string,
  insured_height: string,
  insured_address: string,
  insured_city_id: string,
  insured_soldier_status:string;

  // 3
  step3Errors: any,
  step3_2Errors: any,
  // 4
  step4Errors: any,
  life_bens: any,
  death_bens: any,
  relation_id: any,
  percent: string,
  priority: string,
  national_code: string,
  birthdayLife: any,
  isLife: boolean,
  step5Errors: any,
  step5_2Errors: any,
  step6Errors: any,
  step6_2Errors: any,
  medical_extra_rate_percent: any;
  policy_holder_medical_extra: any,
  result: any;
  tab?: number;
  isEdited?: boolean;
  data?: any
  options?: any;
  birthday?: string;
  policy_holder_province_id: string
  insured_province_id: string;
  province_list: any;
  insured_city_list: any;
  policy_city_list: any;
  beneficiaryModalStep: number;
  relationPersonList: any;
  filteredRelationPersonList: any;
  relation_with_policy_holder: any;
  cityListLoading: boolean;
  search_city: boolean;
  cityListfiltered: any;
  openConfirmationInformationModal:boolean;
  base64Data :any;
  new_policy_holder:string;
  is_withdrawal_from_savings:boolean;
  base64Loading:boolean;
  sharesList : any;
  defaultList : any;
  shareId:string;
  checkPercent:any;
  person_type:string;
  tabIndex:any;
  tabs:any;
  pdfData:any;
  offerResponse:any;
  prePaymentLoading:boolean;

}
export class IssuingController extends Component<IProps, IState> {
  datePickerRefHolder: any;
  datePickerRefInsured: any;
  constructor(props: any) {
    super(props);
    this.datePickerRefHolder = React.createRef();
    this.datePickerRefInsured = React.createRef();
  }
  state: IState = {
    tabs: [
      { id: 2, label: "جدول تعهدات", pdfType: "UNIVERSAL_PRINT" },
      { id: 1, label: "فرم پیشنهاد", pdfType: "UNIVERSAL_OFFER_PRINT" },
      { id: 3, label: "شرایط عمومی", pdfType: "GENERAL_COVERAGE_PRINT" },

  ],
    pdfData:[],
    checkPercent:"",
    base64Loading:false,
    open: false,
    str: "",
    value: "",
    value2: "",
    openBeneficiaryModal: false,
    startValue: "",
    anchorEl: null,
    step: 1 ,
    insuranceType: "universal",
    contract_id: "",
    // 
    disease_policy_holder: [],
    public_policy_holder: [],
    disease_insured: [],
    public_insured: [],
    contentLoading: false,
    // 1
    step1Errors: [],
    policy_holder_national_code: this.props.userData?.national_code || "",
    insured_national_code:this.props.insuredEqualPolicyHolder ? this.props.userData?.national_code : "",
    inqueryRegisterOfficeData: null,
    inqueryRegisterOfficeData2: null,
    
    hasError: false,
    hasErrorMsg: "",
    step5Errors: [],
    step5_2Errors: [],
    step6Errors: [],
    step6_2Errors: [],
    // 3
    policy_holder_is_married: "",
    policy_holder_mobile: this.props.userData?.phone ,
    policy_holder_postal_code: "",
    policy_holder_address: "",
    policy_holder_weight: "",
    policy_holder_height: "",
    policy_holder_city_id: "",
    policy_holder_soldier_status:"Not Done",


    insured_is_married: "",
    insured_mobile: "",
    insured_postal_code: "",
    insured_address: "",
    insured_weight: "",
    insured_height: "",
    insured_city_id: "",
    insured_soldier_status:"Not Done",
    insured_city_list: [],
    policy_city_list: [],
    // 3
    step3Errors: [],
    step3_2Errors: [],
    province_list: [],
    // 4
    step4Errors: [],

    life_bens: [
    ],
    death_bens: [
    ],

    relation_id: "",
    percent: "",
    priority: "",
    national_code: "",
    birthdayLife: "",
    beneficiaryModalStep: 1,

    isLife: true,

    medical_extra_rate_percent: "",
    policy_holder_medical_extra: "",
    result: [],
    tab: 0,
    isEdited: false,
    data: {
      labels: [],
      datasets: [
      ]
    },
    options: {
    },
    birthday: "",

    policy_holder_province_id: "",
    insured_province_id: "",
    relationPersonList: [],
    relation_with_policy_holder: "",
    filteredRelationPersonList: "",
    cityListLoading: false,
    search_city: false,
    cityListfiltered: [],
    openConfirmationInformationModal:false,
  base64Data : "",
  new_policy_holder:"LEGAL HEIRS",
  is_withdrawal_from_savings:true,
  sharesList:[],
  shareId:"",
  defaultList : [],
  person_type:"",
  tabIndex:1,
  offerResponse:"",
  prePaymentLoading:false

  };


  id: any = this.state.open ? 'simple-popper' : undefined;
  // search = async (e: any) => {
  //   this.setState({ str: e })
  // };

  changeNationalCodeHolder = (e: string) => {
    this.setState({ policy_holder_national_code: e })
    if (this.props.insuredEqualPolicyHolder) {
      this.setState({
        insured_national_code: e,
      })
    }
  }
  calculationSharePercentage = (val: any) => {
    const { percent, priority, isLife, life_bens, death_bens } = this.state;
    const list = isLife ? life_bens : death_bens

    let checkPercent = list.filter((item: { priority: string; }) => item.priority === priority);
    let total = Number(val);
    checkPercent.map((item: { percent: string; }) => {
      total += Number(item?.percent);
    });
    if (Number(total) > 100) {
      return false
    } else {
      return true
    }

  }
  calculationOrderPriority = (val: any) => {
    const { isLife, life_bens, death_bens } = this.state;
    const list = isLife ? life_bens : death_bens
    if ((list.length === 0 || list.length > 0) && Number(val) === 1) return true;
    else if (list.length > 0 && Number(val) > 0) {
      for (let i = 0; i < list.length; i++) {
        if (Number(list[list.length - 1].priority) === Number(val) - 1) {
          return true
        } else {
          return false
        }
      }
    }
  }
  async checkObj() {

    const { relation_id, percent, priority, national_code , birthdayLife, isLife, shareId , person_type} = this.state;
    if (relation_id === "") {
      const shebaCodeSchema = yup.object({
        relation_id: yup.string().required("لطفاً ابتدا نسبت با بیمه شده را انتخاب کنید"),
      });
    
      try {
        this.setState({ step4Errors: [] });
    
        await shebaCodeSchema.validate({ relation_id }, { abortEarly: false });
      } catch (err: any) {
        this.setState({ step4Errors: err.inner });
        return; // از ادامه اجرا جلوگیری کن
      }
    }
    
    if (person_type === "") {
      const shebaCodeSchema = yup.object({
        person_type: yup.string().required("انتخاب نوع شخص اجباری می باشد"),
      });
    
      try {
        this.setState({ step4Errors: [] });
    
        await shebaCodeSchema.validate({ person_type }, { abortEarly: false });
      } catch (err: any) {
        this.setState({ step4Errors: err.inner });
        return;
      }
    }
    else{


    const shebaCodeSchema = yup.object({
     
        
      percent: yup.string().when('$condition', (condition, schema) =>
      relation_id === 68 || ( priority === "1" && Number(shareId) === Number(102) ) ? schema : 
      schema.required("درصد سهم اجباری می باشد").test("percent", `   مجموع درصد سهم در یک اولویت نمیتواند بیشتر از 100 باشد `,
          (value) => {
            if (this.calculationSharePercentage(value)) {
              return true;
            } else {
              return false
            }
          })  ),
      // .test("percent", `    درصد سهم سهم نمیتواند بیشتر از 100 باشد  `,
      // (value) => {
      //   if (Number(value) > 100) {
      //     return false;
      //   } else {
      //     return true
      //   }
      // }),
      // percent: yup.string().required("درصد سهم اجباری می باشد"),
      priority: yup
  .string()
  .required("اولویت اجباری می باشد")
  .test(
    "priority",
    "اولویت کوچک تر از اولویت انتخاب شده وجود ندارد",
    (value) => this.calculationOrderPriority(value)
  )
  .test(
    "priority-range",
    "امکان ثبت در این اولویت وجود ندارد",
    (value) => {
      const { isLife, life_bens, death_bens } = this.state;

      const list = isLife ? life_bens : death_bens;

      const hasRelation68AndPercent101 = list?.some(
        (item:any) => Number(item.relation_id) === 68 && Number(item.percent) === 101
      );
      const hasPercent102 = list?.some((item:any) => Number(item.percent) === 102);

      return !(hasRelation68AndPercent101 && hasPercent102 && value === "1");
    }
  ),
      national_code: yup.string().when('$condition', (condition, schema) => 
  Number(relation_id) !== 1 && Number(relation_id) !== 2 && Number(relation_id) !== 3 && Number(relation_id) !== 67
    ? yup.string().when('$condition', (condition, schema) => 
        person_type==="1" 
          ? schema.required("شناسه ملی اجباری می‌باشد").length(11, "شناسه ملی باید 11 رقمی باشد.") 
          : schema.required("کد ملی اجباری می‌باشد").length(10, "کد ملی باید 10 رقمی باشد.")
      ) .test(
        "national_code-equality",
        "کد ملی نمی‌تواند برابر با کد ملی بیمه‌شده باشد",
        (value) => {
          const { insured_national_code , isLife} = this.state; 
          if(!isLife && (Number(value) === Number(insured_national_code)) ){
            return false
          }
          return  true;
        }
      )
    : schema
),
      birthdayLife: yup.string().when('$condition', (condition, schema) =>
        (Number(relation_id) !== 1 && Number(relation_id) !== 2 && Number(relation_id) !== 3 && Number(relation_id) !== 67 && person_type !=="1" )  ?
      schema.required("تاریخ تولد اجباری می باشد") : schema
      ),
        shareId: yup.string().when('$condition', (condition, schema) =>
            Number(relation_id) === 68 ?
                schema.required("سهم اجباری می باشد") : schema
      ),
    });

    try {
      this.setState({ step4Errors: [] })

      await shebaCodeSchema.validate({
        relation_id, percent, priority, national_code, birthdayLife, shareId
      }, { abortEarly: false });


      if (![1, 2, 3, 67].includes(relation_id)) {
        this.InqueryRegisterOfficeExceptionRelation();
      } else {
        this.addToTable();
      }


    } catch (err: any) {
      this.setState({ step4Errors: err.inner })

    }}
  };
  //add
  addLifeObj = () => {

    this.setState({
      openBeneficiaryModal: !this.state.openBeneficiaryModal
    })


    const updateInfo = [...this.state?.life_bens]
    const { relation_id, percent, priority, national_code, birthdayLife, inqueryRegisterOfficeData2 , shareId} = this.state;
    const obj = {
      relation_id: relation_id,
      percent:  shareId || percent,
      priority: priority,
      national_code: national_code,
      birthday: birthdayLife ? birthdayLife : "",
      first_name:  inqueryRegisterOfficeData2?.policy_holder?.type_id === 3 ? inqueryRegisterOfficeData2?.policy_holder?.last_name : (inqueryRegisterOfficeData2?.policy_holder?.Name || ""),

      last_name: inqueryRegisterOfficeData2?.policy_holder?.Family || "",

      fatherName: inqueryRegisterOfficeData2?.policy_holder?.FatherName || "",


      gender: inqueryRegisterOfficeData2?.policy_holder?.Gender || "",

    }
    updateInfo.push(obj);
    this.setState({ life_bens: updateInfo })
  }
  addDeathObj = () => {

    this.setState({
      openBeneficiaryModal: !this.state.openBeneficiaryModal
    })
    const updateInfo = [...this.state?.death_bens]
    const { relation_id, percent, priority, national_code, birthdayLife, inqueryRegisterOfficeData2 , shareId } = this.state;
    const obj = {
      relation_id: relation_id,
      percent:   shareId || percent,
      priority: priority,
      national_code: national_code,
      birthday: birthdayLife ? birthdayLife : "",
      first_name:   inqueryRegisterOfficeData2?.policy_holder?.type_id === 3 ? inqueryRegisterOfficeData2?.policy_holder?.last_name : (inqueryRegisterOfficeData2?.policy_holder?.Name || ""),

      last_name: inqueryRegisterOfficeData2?.policy_holder?.Family || "",

      fatherName: inqueryRegisterOfficeData2?.policy_holder?.FatherName || "",


      gender: inqueryRegisterOfficeData2?.policy_holder?.Gender || "",
    }
    updateInfo.push(obj);
    this.setState({ death_bens: updateInfo })
  }

  addToTable = () => {
    this.setState({ inqueryRegisterOfficeData2: [] })

    const { isLife } = this.state;
    if (isLife) {
      this.addLifeObj();

    } else {
      this.addDeathObj();
    }
  }
  handleOpenModal = (isLife: boolean) => {
    const {
      relationPersonList,life_bens,death_bens
    } =
      this.state;

    this.setState({
      openBeneficiaryModal: !this.state.openBeneficiaryModal, relation_id: "", isLife: isLife,
      percent: "",
      priority: "",
      national_code: "",
      birthdayLife: "",
      beneficiaryModalStep: 1,
      shareId:""
    })


    if (this.props.insuredEqualPolicyHolder) {

      // filteredRelationPersonList
      if (isLife) {

        // بیمه گذار 

        // this.setState({
        //   filteredRelationPersonList: relationPersonList.filter((x: { value: number; }) => x.value !== 2 && x.value !== 1  && x.value !== 67)
        // })



        this.setState({
          filteredRelationPersonList: relationPersonList.filter((x: { value: number;}) => {
            if (life_bens.length > 0) {
              return x.value !== 2 && x.value !== 1 && x.value !== 67 && x.value !== 68;
            }else{
              return x.value !== 2 && x.value !== 1 && x.value !== 67;
            }
          })
        });

      } else {

        //بیمه شده و بیمه گذار 
        this.setState({
          filteredRelationPersonList: relationPersonList.filter((x: { value: number;}) => {
            if (death_bens.length > 0) {
              return x.value !== 2 && x.value !== 3 && x.value !== 68;
            }else{
              return x.value !== 2 && x.value !== 3;
            }
          })
        });
        // this.setState({
        //   filteredRelationPersonList: relationPersonList.filter((x: { value: number; }) => x.value !== 2 && x.value !== 3 )
        // })
      }

    } else {
      if (isLife) {
        // no filter 
        // this.setState({
        //   filteredRelationPersonList: relationPersonList.filter((x: { value: number; }) => x.value !== 1 && x.value !== 67 )
        // })

        this.setState({
          filteredRelationPersonList: relationPersonList.filter((x: { value: number;}) => {
            if (life_bens.length > 0) {
              return  x.value !== 1 && x.value !== 67 && x.value !== 68;
            }else{
              return  x.value !== 1 && x.value !== 67;
            }
          })
        });


      } else {

        //بیمه شده


        // this.setState({
        //   filteredRelationPersonList: relationPersonList.filter((x: { value: number; }) => x.value !== 3)

        // })

        this.setState({
          filteredRelationPersonList: relationPersonList.filter((x: { value: number;}) => {
            if (death_bens.length > 0) {
              return x.value !== 3 && x.value !== 68;
            }else{
              return x.value !== 3;
            }
          })
        });
      }
    }

  }

  //update
  handleHideModal = () => {
    this.setState({ openBeneficiaryModal: !this.state.openBeneficiaryModal, inqueryRegisterOfficeData2: [], step4Errors: [] })
  }
  //remove
  removeLifeObj(index: any, priority: number) {
    const {life_bens } = this.state;
    const hasRelation68AndPercent101 = life_bens?.some(
      (item:any) => Number(item.relation_id) === 68 && Number(item.percent) === 101
    );
    const hasPercent102 = life_bens?.some((item:any) => Number(item.percent) === 102);
    var array = [...this.state.life_bens]; // make a separate copy of the array
    // var index = array.indexOf(e.target.value)

    if (index !== -1) {
      if (array.some(e => Number(e.priority) > Number(priority))) {
        // We found at least one object that we're looking for!
        toast.error("در صورت وجود اولویتی بالاتر , امکان حذف اولویت پایین تر وجود ندارد . ")
      } else if(index === 0 && hasRelation68AndPercent101 && hasPercent102){
        toast.error("لطفا از پایین ترین ردیف شروع به حذف کنید")
      }else {
        array.splice(index, 1);
        this.setState({ life_bens: array });
      }
    }
  }
  removeDeathObj(index: any, priority: number) {
    const {death_bens } = this.state;
  const hasRelation68AndPercent101 = death_bens?.some(
    (item:any) => Number(item.relation_id) === 68 && Number(item.percent) === 101
  );
  const hasPercent102 = death_bens?.some((item:any) => Number(item.percent) === 102);
    var array = [...this.state.death_bens]; // make a separate copy of the array
    // var index = array.indexOf(e.target.value)
    if (index !== -1) {

      if (array.some(e => Number(e.priority) > Number(priority))) {
        // We found at least one object that we're looking for!
        toast.error("در صورت وجود اولویتی بالاتر , امکان حذف اولویت پایین تر وجود ندارد . ")
      } else if(index === 0 && hasRelation68AndPercent101 && hasPercent102){
        toast.error("لطفا از پایین ترین ردیف شروع به حذف کنید")
      }else {
        array.splice(index, 1);
        this.setState({ death_bens: array });
      }



    }
  }

  InqueryRegisterOfficeExceptionRelation = async () => {
    this.setState({ contentLoading: true })
    const { national_code, birthdayLife } = this.state;

    try {
      const response = await service.InqueryRegisterOffice.inqueryRegisterOffice({
        policy_holder_national_code: fixNumbers(national_code),
        policy_holder_birthday: moment(fixNumbers(new DateObject(birthdayLife).format("YYYY-MM-DD")), "jYYYY/jMM/jDD").format("YYYY-MM-DD"),
        insured_equal_policy_holder: true
      });
      if (response) {
        if (response.status === 400) {
          toast.error(response?.data?.message);
        } else {
          this.setState({ beneficiaryModalStep: 2, inqueryRegisterOfficeData2: response?.data?.data })
        }
        this.setState({ contentLoading: false })
      }
    } catch (error) {
      this.setState({ contentLoading: false })
    }
  }

  //
  changeNationalCodeInsured = (e: any) => {
    this.setState({ insured_national_code: e })
    if (this.props.insuredEqualPolicyHolder) {
      this.setState({
        policy_holder_national_code: e,
      })
    }
  }
  handleClick = (event: any) => {
    this.setState({ anchorEl: this.state.anchorEl ? null : event.currentTarget });
    this.setState({ open: this.state.anchorEl ? null : Boolean(event.currentTarget) });
  };
  increaseSteper = async (type: boolean) => {
    // this.setState({ tab: 0 })

    if (this.state.step === 1) {
      this.checkStep1()
    }
    if (this.state.step === 2) {
      if (this.props.insuredEqualPolicyHolder === false && this.state.tab === 0) {
        this.setState({ tab: 1 })
      } else {
        this.setState({ step: this.state.step + 1, tab: 0 })
      }
    }
    if (this.state.step === 3) {


      if (this.props.insuredEqualPolicyHolder === false) {
        const checkStep3Status = await this.checkStep3();
        const checkStep3_2Status = await this.checkStep3_2()
        if (checkStep3Status && checkStep3_2Status) {
          this.setState({ step: this.state.step + 1 })
        } else if (!checkStep3Status && checkStep3_2Status) {
          this.setState({ tab: 0 })
        } else if (checkStep3Status && !checkStep3_2Status) {
          this.setState({ tab: 1 })
        } else {
          this.setState({ tab: 0 })
        }
      } else {
        const checkStep3Status = await this.checkStep3();
        if (checkStep3Status) {
          this.setState({ step: this.state.step + 1 })
        }

      }

    }
    if (this.state.step === 4) {
      this.checkStep4()
    }
    if (this.state.step === 5) {
      if (this.props.insuredEqualPolicyHolder === false) {
        const checkStep5Status = await this.checkStep5();
        const checkStep5_2Status = await this.checkStep5_2()
        if (checkStep5Status && checkStep5_2Status) {
          this.setState({ step: this.state.step + 1, tab: 0 })
        } else if (!checkStep5Status && checkStep5_2Status) {
          this.setState({ tab: 0 })
        } else if (checkStep5Status && !checkStep5_2Status) {
          this.setState({ tab: 1 })
        } else {
          this.setState({ tab: 0 })
        }
      } else {
        const checkStep5Status = await this.checkStep5();
        if (checkStep5Status) {
          this.setState({ step: this.state.step + 1 })
        }
      }
    }
    if (this.state.step === 6) {
      if (this.props.insuredEqualPolicyHolder === false) {
        const checkStep6Status = await this.checkStep6();
        const checkStep6_2Status = await this.checkStep6_2()
        if (checkStep6Status && checkStep6_2Status) {
          // this.createIssuing()
          this.setState({ openConfirmationInformationModal: true })
        } else if (!checkStep6Status && checkStep6_2Status) {
          this.setState({ tab: 0 })
        } else if (checkStep6Status && !checkStep6_2Status) {
          this.setState({ tab: 1 })
        } else {
          this.setState({ tab: 0 })
        }
      } else {
        const checkStep6Status = await this.checkStep6();
        if (checkStep6Status) {
          // this.createIssuing()
          this.setState({ openConfirmationInformationModal: true })
        }

      }
    }
  }
  decreaseSteper = () => {
    this.setState({ tab: 0 })

    const { step } = this.state;
    const { inqueryData } = this.props;
    const shouldSkipQuestions = inqueryData?.start_death_asset <= inqueryData?.minimum_insurance_premium;
    if (this.state.step > 1)
    if (step === 7 && shouldSkipQuestions) {
        this.setState({ step: 4 });
    } else if (step > 1) {
        this.setState({ step: step - 1 });
    }
  }

  inqueryRegisterOffice = async () => {
    const { policy_holder_national_code,
      insured_national_code,

    } = this.state;
    this.setState({ contentLoading: true })
    this.setState({ hasError: false })
    try {
      const response = await service.InqueryRegisterOffice.inqueryRegisterOffice({
        policy_holder_national_code:fixNumbers(policy_holder_national_code),
        policy_holder_birthday: this.props.inqueryData?.holder_birthday,
        insured_national_code:fixNumbers(insured_national_code),
        insured_birthday: this.props.inqueryData?.insured_birthday,
        insured_equal_policy_holder: this.props.insuredEqualPolicyHolder
      });
      if (response) {
        if (response.status === 400 || response.status === 404) {
          this.setState({ hasError: true, hasErrorMsg: response?.data?.message })

          // toast.error(response?.data?.message);
        } else {

          this.setState({ step: this.state.step + 1, inqueryRegisterOfficeData: response?.data?.data })
        }
        this.setState({ contentLoading: false })
      }
    } catch (error) {
      this.setState({ contentLoading: false })
    }
  };

  async checkStep1() {
    const { policy_holder_national_code,
      insured_national_code,
    } = this.state;
    const { insuredEqualPolicyHolder
    } = this.props;
    const shebaCodeSchema = yup.object({
      insured_national_code: yup.string().required("کدملی اجباری می باشد").matches(nationalCodeRegexp, "فرمت وارد شده صحیح نمی باشد. ").test('checkEqualityAndX', 'کد ملی بیمه شده و بیمه گذار نمیتواند یکسان باشد ', function(value) {
        const { insured_national_code, policy_holder_national_code } = this.parent;
        if (insured_national_code === policy_holder_national_code && insuredEqualPolicyHolder === false) {
          return false;
        }
        return true;
      }),
      policy_holder_national_code: yup.string().required("کدملی اجباری می باشد").matches(nationalCodeRegexp, "فرمت وارد شده صحیح نمی باشد. ")
    });
    try {
      await shebaCodeSchema.validate({
        policy_holder_national_code,
        insured_national_code,
      }, { abortEarly: false });
      this.inqueryRegisterOffice()
      this.setState({ step1Errors: [] })
    } catch (err: any) {
      this.setState({ step1Errors: err.inner })
    }
  };
  async checkStep3() {

    const {
      policy_holder_is_married,
      policy_holder_mobile,
      policy_holder_postal_code,
      policy_holder_weight,
      policy_holder_height,
      policy_holder_address,
      policy_holder_province_id,
      policy_holder_city_id,
      policy_holder_soldier_status,

    } = this.state;
    const shebaCodeSchema = yup.object({
      policy_holder_is_married: yup.string().required("وضعیت تاهل اجباری می باشد"),
      policy_holder_mobile: yup.string().required("شماره همراه اجباری می باشد").matches(mobileNumberIranRegexp, "فرمت وارد شده صحیح نمی باشد."),
      policy_holder_postal_code: yup.string().required(" کدپستی اجباری می باشد").min(10, "  کدپستی 10 کاراکتر می باشد ").max(10, "  کدپستی 10 کاراکتر می باشد "),
      policy_holder_weight: yup.string().typeError("لطفا عدد وارد کنید").required(" وزن اجباری می باشد").test("not-zero", "وزن نمی‌تواند صفر باشد", (value) => value !== "0" && value !== "۰"),
      policy_holder_height: yup.string().typeError("لطفا عدد وارد کنید").required(" قد اجباری می باشد").test("not-zero","قد نمی‌تواند صفر باشد",(value) => value !== "0" && value !== "۰"),
      policy_holder_address: yup.string().required(" نشانی اجباری می باشد").min(5, "  نشانی نمیتواند کمتر از 5 کاراکتر  باشد ").max(255, "  نشانی  نمیتواند بیشتر از 255  کاراکتر  باشد "),
      policy_holder_province_id: yup.string().required(" استان اجباری می باشد"),
      policy_holder_city_id: yup.string().required(" شهر اجباری می باشد"),
      // policy_holder_soldier_status: yup.string().required(" وضعیت سربازی اجباری می باشد"),
    });
    try {
      await shebaCodeSchema.validate({
        policy_holder_is_married,
        policy_holder_mobile,
        policy_holder_postal_code,
        policy_holder_weight,
        policy_holder_height,
        policy_holder_address,
        policy_holder_city_id,
        policy_holder_soldier_status,
        policy_holder_province_id,



      }, { abortEarly: false });

      this.setState({ step3Errors: [] })
      return true
    } catch (err: any) {
      this.setState({ step3Errors: err.inner })
      return false
    }
  };
  async checkStep3_2() {
    const {
      insured_is_married,
      insured_mobile,
      insured_postal_code,
      insured_weight,
      insured_height,
      insured_address,
      insured_province_id,
      insured_city_id,
      relation_with_policy_holder,
      insured_soldier_status

    } = this.state;
    const shebaCodeSchema = yup.object({
      insured_is_married: yup.string().required("وضعیت تاهل اجباری می باشد"),
      insured_mobile: yup.string().required("شماره همراه اجباری می باشد").matches(mobileNumberIranRegexp, "فرمت وارد شده صحیح نمی باشد."),
      insured_postal_code: yup.string().required(" کدپستی اجباری می باشد").min(10, "  کدپستی 10 کاراکتر می باشد ").max(10, "  کدپستی 10 کاراکتر می باشد "),
      insured_weight: yup.string().typeError("لطفا عدد وارد کنید").required(" وزن اجباری می باشد").test("not-zero", "وزن نمی‌تواند صفر باشد", (value) => value !== "0" && value !== "۰"),
      insured_height: yup.string().typeError("لطفا عدد وارد کنید").required(" قد اجباری می باشد").test("not-zero", "قد نمی‌تواند صفر باشد", (value) => value !== "0" && value !== "۰"),
      insured_address: yup.string().required(" نشانی اجباری می باشد").min(5, "  نشانی نمیتواند کمتر از 5 کاراکتر  باشد ").max(255, "  نشانی  نمیتواند بیشتر از 255  کاراکتر  باشد "),
      relation_with_policy_holder: yup.string().required(" نسبت با بیمه گذار اجباری می باشد"),
      insured_province_id: yup.string().required(" استان اجباری می باشد"),
      insured_city_id: yup.string().required(" شهر اجباری می باشد"),
      // insured_soldier_status: yup.string().required(" وضعیت سربازی اجباری می باشد")
    });
    try {
      await shebaCodeSchema.validate({

        insured_is_married,
        insured_mobile,
        insured_postal_code,
        insured_weight,
        insured_height,
        insured_address,
        relation_with_policy_holder,
        insured_province_id,
        insured_city_id,
        insured_soldier_status


      }, { abortEarly: false });
      this.setState({ step3_2Errors: [] })
      return true

    } catch (err: any) {

      this.setState({ step3_2Errors: err.inner })
      return false
    }
  };


  calculationSharePercentageGroup = (list: any) => {
    var holder: any = {};
    list.forEach(function (d: { priority: string | number; percent: any; value: any; }) {
      if (holder.hasOwnProperty(d.priority)) {
        holder[d.priority] = Number(holder[d.priority]) + Number(d.percent);
      } else {
        holder[d.priority] = Number(d.percent);
      }
    });

    var obj2 = [];

    for (var prop in holder) {
      obj2.push({ priority: prop, percent: holder[prop] });
    }

    if (obj2.find(({ percent }) => percent < 100)?.percent) {
      return false
    } else {
      return true
    }
  }



  async checkStep4() {
    this.setState({ tab: 0 })

    const {
      death_bens,
      life_bens

    } = this.state;

    const shebaCodeSchema = yup.object().shape({
      death_bens: yup.array().test("death_bens", `  حداقل یک مورد اجباری است  `,
        (value) => {
          if (value?.length === 0) {
            return false;
          } else {
            return true
          }
        })
        .test("death_bens", `   مجموع درصد سهم در یک اولویت نمیتواند کمتر از 100 باشد `,
          (value) => {
            if (this.calculationSharePercentageGroup(death_bens)) {
              return true;
            } else {
              return false
            }
          })
          .test("death_bens_relation_condition", ` برای این اولویت استفاده کننده کسر از سرمایه انتخاب نشده است  `, (value) => {
            const hasRelation68AndPercent101 = value?.some((item) => Number(item.relation_id) === 68 && Number(item.percent) === 101);
            const hasPercent102 = value?.some((item) => Number(item.percent) === 102);
            if (hasRelation68AndPercent101 && !hasPercent102) {
              return false;
            }
            return true;
          }),
          
      life_bens: yup.array()
        .test("life_bens", `  حداقل یک مورد اجباری است  `,
          (value) => {
            if (value?.length === 0) {
              return false;
            } else {
              return true;
            }
          })
        .test("life_bens", `   مجموع درصد سهم در یک اولویت نمیتواند کمتر از 100 باشد `,
          (value) => {
            if (this.calculationSharePercentageGroup(life_bens)) {
              return true;
            } else {
              return false
            }
          })
          .test("life_bens_relation_condition",  ` برای این اولویت استفاده کننده کسر از سرمایه انتخاب نشده است  `, (value) => {
            const hasRelation68AndPercent101 = value?.some((item) => Number(item.relation_id) === 68 && Number(item.percent) === 101);
            const hasPercent102 = value?.some((item) => Number(item.percent) === 102);
            if (hasRelation68AndPercent101 && !hasPercent102) {
              return false;
            }
            return true;
          }),
    });

    try {
      await shebaCodeSchema.validate({
        death_bens,
        life_bens

      }, { abortEarly: false });


      this.setState({ step4Errors: [] })
      this.nextStep()


    } catch (err: any) {

      this.setState({ step4Errors: err.inner })

    }
  };



  handleChange = (e: any) => {
    this.setState({ value: e.target.value })
  };

  handleChangeBD = (value: any) => {
    this.setState({
      birthday: value,
    })

  }



  getRelationPerson = async () => {
    this.setState({ contentLoading: true })

    try {
      const response = await service.RelationPerson.relationPerson();
      if (response) {
        this.setState({ relationPersonList: response.data?.data })
        this.getProvinceList()
        // this.getQuestionnaireList()

        this.setState({ contentLoading: false })

      }
    } catch (error: any) {
      if (error && error.status) {
        this.setState({ contentLoading: false })
      }
    }
  };


  getProvinceList = async () => {
    try {
      const response = await service.General.provinceList();
      if (response) {

        this.setState({
          province_list: response?.data?.data,
        })
      }
    } catch (error: any) {
      if (error && error.status) {
      }
    }
  };

  cityTimeout: string | number | NodeJS.Timeout | undefined;
  selectedProvince = (e: any) => {
    this.setState({ policy_holder_province_id: e.target.value })
    clearTimeout(this.cityTimeout);
    this.cityTimeout = setTimeout(async () => {
      try {
        this.getCityList(e.target.value,false)
      } catch (error) {
        // throw error;
      }
    }, 800);
  };

  city2Timeout: string | number | NodeJS.Timeout | undefined;
  selectedInsuredProvince = (e: any) => {
    this.setState({ insured_province_id: e.target.value })
    clearTimeout(this.city2Timeout);
    this.city2Timeout = setTimeout(async () => {
      try {
        this.getCityList(e.target.value,true)
      } catch (error) {
        // throw error;
      }
    }, 800);
  };





  searchTimeoutH: string | number | NodeJS.Timeout | undefined;
  getCityList = (provinceId: string,insuredType:boolean) => {
    this.setState({ cityListLoading: true })
    clearTimeout(this.searchTimeoutH);
    this.searchTimeoutH = setTimeout(async () => {
      try {
        const response = await service.General.cityList(provinceId);
        if (response) {
          if(insuredType){
          this.setState({ insured_city_list: response.data?.data })
          }else{
          this.setState({ policy_city_list: response.data?.data })
          }
          this.setState({ cityListfiltered: response?.data?.data, cityListLoading: false })

          // return response;
        } else {
          this.setState({ cityListLoading: false })

        }
      } catch (error) {
        // throw error;
      }
    }, 1000);
  };
  
  getQuestionnaireList = async () => {
    try {
      const response = await service.Questionnaire.list(this.props.insuredEqualPolicyHolder);
      if (response) {

        this.setState({
          disease_policy_holder: response.data?.data?.policy_holder?.disease_policy_holder,

          public_policy_holder: response.data?.data?.policy_holder?.public_policy_holder,


          disease_insured: response.data?.data?.insured?.disease_insured,

          public_insured: response.data?.data?.insured?.public_insured

        })
      }
    } catch (error: any) {
      if (error && error.status) {
      }
    }
  };


  onQuestionPolicyHolderChange(index: any, name: string, val: string) {

    var data = [...this.state.disease_policy_holder];
    data[index][name] = val;
    if(name === "default_value") {
      data[index]["default_description"] = "";
    }
    this.setState({ disease_policy_holder: data });
  }
  onQuestionPolicyPublicHolderChange(index: any, name: string, val: string) {
    var data = [...this.state.public_policy_holder];
    data[index][name] = val;
    if(name === "default_value") {
      data[index]["default_description"] = "";
    }
    this.setState({ public_policy_holder: data });
  }


  onQuestionInsuredChange(index: any, name: string, val: string) {

    var data = [...this.state.disease_insured];
    if(name === "default_value") {
      data[index]["default_description"] = "";
    }
    data[index][name] = val;
    this.setState({ disease_insured: data });
  }
  onQuestionInsuredPublicChange(index: any, name: string, val: string) {
    var data = [...this.state.public_insured];
    if(name === "default_value") {
      data[index]["default_description"] = "";
    }
    data[index][name] = val;
    this.setState({ public_insured: data });
  }
  handleChangeRelationId = (e: any) => {
    this.setState({ relation_id: e.target.value });
    if(![41,65,68].includes(e.target.value)){
      this.setState({person_type:"0"})
    }else{

      this.setState({person_type:""})
    }

    if (e.target.value === 68 || this.checkRelationAndPercent()) {
      const shareId = e.target.value === 68 ? "101" : "102";
      this.setState({ priority: "1", shareId });
    }else{
      this.setState({ shareId : ""});
    }
    this.limitationBeneficiary("68")
    if (e.target.value === 1 || e.target.value === 2 || e.target.value === 3 && e.target.value === 67) {
      this.setState({ birthdayLife: "", national_code: "", inqueryRegisterOfficeData2: null })
    }
  }
  handleChangePersonType = (e: any) => {
  this.setState({ person_type: e.target.value })
  this.setState({ birthdayLife: "" , inqueryRegisterOfficeData2: null })
  }
  async createIssuing() {
    const {
      policy_holder_national_code,
      policy_holder_mobile,
      policy_holder_city_id,
      policy_holder_soldier_status,
      policy_holder_province_id,
      policy_holder_address,
      policy_holder_postal_code,
      policy_holder_weight,
      policy_holder_height,
      policy_holder_is_married,
      insured_national_code,
      insured_mobile,
      insured_city_id,
      insured_soldier_status,
      insured_province_id,
      insured_address,
      insured_postal_code,
      insured_weight,
      insured_height,
      insured_is_married,
      relation_with_policy_holder,
      life_bens,
      death_bens,
      disease_policy_holder,
      public_policy_holder,

      disease_insured,
      public_insured,
      new_policy_holder,
      is_withdrawal_from_savings,
      tabs
    } = this.state;
    this.setState({
      contentLoading: true
    })

    const isuuingSchema = yup.object({
    });
    try {
      await isuuingSchema.validate({}, { abortEarly: false });

      const response = await service.UniversalOffer.create({

        new_policy_holder,
        is_withdrawal_from_savings,
        universal_offer_id:window.location.pathname.split("/")[2] ? window.location.pathname.split("/")[2] : null , 


        policy_holder_national_code: fixNumbers(policy_holder_national_code),
        policy_holder_mobile:fixNumbers(policy_holder_mobile),
        policy_holder_city_id,
        policy_holder_soldier_status,
        policy_holder_province_id,
        policy_holder_address,
        policy_holder_postal_code:fixNumbers(policy_holder_postal_code),
        policy_holder_weight:fixNumbers(policy_holder_weight),
        policy_holder_height:fixNumbers(policy_holder_height),
        policy_holder_is_married,

        insured_national_code: this.props.insuredEqualPolicyHolder ? fixNumbers(policy_holder_national_code) : fixNumbers(insured_national_code),
        insured_mobile: this.props.insuredEqualPolicyHolder ? fixNumbers(policy_holder_mobile) : fixNumbers(insured_mobile),
        insured_city_id: this.props.insuredEqualPolicyHolder ? policy_holder_city_id : insured_city_id,
        insured_soldier_status: this.props.insuredEqualPolicyHolder ? policy_holder_soldier_status : insured_soldier_status,
        insured_province_id: this.props.insuredEqualPolicyHolder ? policy_holder_province_id : insured_province_id,
        insured_address: this.props.insuredEqualPolicyHolder ? policy_holder_address : insured_address,
        insured_postal_code: this.props.insuredEqualPolicyHolder ? fixNumbers(policy_holder_postal_code) : fixNumbers(insured_postal_code),
        insured_weight: this.props.insuredEqualPolicyHolder ? fixNumbers(policy_holder_weight) : fixNumbers(insured_weight),
        insured_height: this.props.insuredEqualPolicyHolder ? fixNumbers(policy_holder_height) : fixNumbers(insured_height),
        insured_is_married: this.props.insuredEqualPolicyHolder ? policy_holder_is_married : insured_is_married,
        policy_holder_questions: disease_policy_holder.concat(public_policy_holder).map((el: any) => ({
          value: el.default_value,
          description: el.default_description ? el.default_description : "-",
          question_id: el.id,
          // date:"",
          questioner_id: el.questionnaire_id
        })),
        insured_questions: this.props.insuredEqualPolicyHolder ?

          null

          : disease_insured.concat(public_insured).map((el: any) => ({
            value: el.default_value,
            description: el.default_description ? el.default_description : "-",
            question_id: el.id,
            // date:"",
            questioner_id: el.questionnaire_id
          }))
        ,

        relation_with_policy_holder: this.props.insuredEqualPolicyHolder === true ? "2" : relation_with_policy_holder,
        diseases_asset_percent: 0, //mr kazemi said 
        life_bens:
          life_bens.map((el: any) => ({
            relation_id: el.relation_id,
            percent: el.percent,
            priority: el.priority,
            national_code: el.national_code === "" ? null : el.national_code,
            birthday: el.birthday === "" ? null : fixNumbers(el.birthday.convert()?.format("YYYY-MM-DD")),
          })),
        death_bens: death_bens.map((el: any) => ({
          relation_id: el.relation_id,
          percent: el.percent,
          priority: el.priority,
          national_code: el.national_code === "" ? null : el.national_code,
          birthday: el.birthday === "" ? null : fixNumbers(el.birthday.convert()?.format("YYYY-MM-DD")),
        })),
        agent_code: "100",
        inquery_data: this.props.inqueryData
      }
      );
      if (response) {
        if(response?.status === 200){
        const offerId = response.data.data.offer_id;

        this.setState({
          offerResponse : response.data.data

        })
        const pdfResponses = await Promise.all(
          tabs.map(async (tab:any) => {
            const pdfResponse = await axios.post(
              `${AppConstants.base_url_api}universalreport/`,
              {
                policy_id: offerId,
                insurance_type: "Universal",
                pdf_type: tab.pdfType,
              },
              {
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  Authorization: `${Cookies.get("acto")}`,
                },
                responseType: "blob",
              }
            );
            return { pdfType: tab.pdfType, pdfBlob: pdfResponse.data };
          })
        );

           // Convert PDFs to base64 URLs and store them in state
      const pdfData = pdfResponses.reduce((acc, { pdfType, pdfBlob }) => {
        const pdfBlobUrl = window.URL.createObjectURL(new Blob([pdfBlob], { type: "application/pdf" }));
        acc[pdfType] = pdfBlobUrl;
        return acc;
      }, {});
      const firstTabPdf = pdfData[tabs[0].pdfType];


        this.setState({
          contentLoading: false,
          result: response?.data?.data,
          pdfData,
          base64Data: firstTabPdf, 
          tabIndex: 0, 
          step: 7, 
          openConfirmationInformationModal: false

        })
      }
      else {
        this.setState({
          contentLoading: false
        })
        toast.error(" ثبت پیشنهاد شما با مشکل مواجه شده است  ")
      }
      } else {
        this.setState({
          contentLoading: false
        })
      }

    } catch (err: any) {
      this.setState({
        contentLoading: false
      })
    }
  };


  handleTabChange = (newValue: number) => {
    const { tabs, pdfData } = this.state;
    let selectedTab = tabs[newValue];

    const selectedPdf = pdfData[selectedTab.pdfType];
  
    this.setState({
      tabIndex: newValue,
      base64Data: selectedPdf, 
    });
  };
  



  clearInquiry = () => {
    this.props.dispatch(inqueryDataa([]))
    window.location.href = `${routes.INSURANCERATE}`
  }
  async PrePayment() {
 if(this.state.offerResponse?.prepayment){
   window.location.href = `/process-complete/${this.state.offerResponse?.offer_id}`
 }else{
      
      try {
        this.setState({ prePaymentLoading: true })
  
        const response = await service.Payment.universalPrePayment({
          policy_id : this.state.offerResponse?.offer_id
  
        });
        if (response) {
          this.setState({ prePaymentLoading: false })
           window.location.href = response?.data?.data?.data?.url
        }
  
      } catch (err: any) {
        this.setState({ prePaymentLoading: false })
      }
      }
    };
  async checkStep5() {

    const {
      public_policy_holder,


    } = this.state;

    const shebaCodeSchema = yup.object().shape({
      public_policy_holder: yup.array()
        .of(
          yup.object().shape(
            {
              default_value: yup.string().required("  اجباری می باشد"),
            },
          )
            .test("default_description", "اجباری می باشد",
              (value: any) => {
                const description_required_status = value?.value_types?.find((item: { value: string; }) => Number(item.value) === Number(value.default_value))?.description_required;
                if (description_required_status === true && (value.default_description === "" || value.default_description === undefined)) {
                  return false;
                } else {
                  return true;
                }
              }),
        )
    });

    try {
      await shebaCodeSchema.validate({
        public_policy_holder

      }, { abortEarly: false });


      this.setState({ step5Errors: [] })
      return true

    } catch (err: any) {

      this.setState({ step5Errors: err.inner })

      return false
    }
  };
  async checkStep6() {

    const {
      disease_policy_holder,

    } = this.state;

    const shebaCodeSchema = yup.object().shape({
      disease_policy_holder: yup.array()
        .of(
          yup.object().shape(
            {
              default_value: yup.string().required("  اجباری می باشد")
            },
          )
            .test("default_description", "اجباری می باشد",
              (value: any) => {
                const description_required_status = value?.value_types?.find((item: { value: string; }) => Number(item.value) === Number(value.default_value)).description_required;
                if (description_required_status === true && (value.default_description === "" || value.default_description === undefined)) {
                  return false;
                } else {
                  return true;
                }
              }),
        ),
    });

    try {
      await shebaCodeSchema.validate({
        disease_policy_holder,

      }, { abortEarly: false });


      this.setState({ step6Errors: [] })
      return true

    } catch (err: any) {

      this.setState({ step6Errors: err.inner })

      return false
    }
  };

  async checkStep5_2() {
    const {
      public_insured
    } = this.state;
    const shebaCodeSchema = yup.object().shape({
      public_insured: yup.array()
        .of(
          yup.object().shape(
            {
              default_value: yup.string().required("  اجباری می باشد")
            },
          )
            .test("default_description", "اجباری می باشد",
              (value: any) => {
                const description_required_status = value?.value_types?.find((item: { value: string; }) => Number(item.value) === Number(value.default_value)).description_required;
                if (description_required_status === true && (value.default_description === "" || value.default_description === undefined)) {
                  return false;
                } else {
                  return true;
                }
              }),
        )
    });
    try {
      await shebaCodeSchema.validate({

        public_insured

      }, { abortEarly: false });


      this.setState({ step5_2Errors: [] })
      return true

    } catch (err: any) {

      this.setState({ step5_2Errors: err.inner })
      return false

    }
  };
  async checkStep6_2() {
    const {
      disease_insured
    } = this.state;
    const shebaCodeSchema = yup.object().shape({
      disease_insured: yup.array()
        .of(
          yup.object().shape(
            {
              default_value: yup.string().required("  اجباری می باشد")
            },
          )
            .test("default_description", "اجباری می باشد",
              (value: any) => {
                const description_required_status = value?.value_types?.find((item: { value: string; }) => Number(item.value) === Number(value.default_value)).description_required;
                if (description_required_status === true && (value.default_description === "" || value.default_description === undefined)) {
                  return false;
                } else {
                  return true;
                }
              }),
        )
    });
    try {
      await shebaCodeSchema.validate({

        disease_insured

      }, { abortEarly: false });


      this.setState({ step6_2Errors: [] })
      return true

    } catch (err: any) {

      this.setState({ step6_2Errors: err.inner })
      return false

    }
  };

//
limitationBeneficiary = async (relation_id?:string): Promise<void> => {
  const { inqueryData } = this.props;

  let parameters = {
    contract_id: inqueryData?.contract_id ? inqueryData?.contract_id.toString() : null,
    insurance_type : "Universal",
    relation_id: relation_id ? fixNumbers(relation_id.toString()) : null,
  };

  const params = new URLSearchParams();

  for (const [key, value] of Object.entries(parameters)) {
    if (value) {
      params.append(key, value);
    }
  }

  try {
    const response = await service.LimitationBeneficiary.list(params.toString());
    if (response) {
var data = response?.data?.data;
if(relation_id === ""){
  this.setState({ defaultList : data }) 
const defaultDeath_bens = []
for (var i = 0; i <  data.default_death_beneficiary?.length; i++) { 
    const obj = {
      

        birthday
          :
         "",

         last_name
          :
          "",
        fatherName
          :
          "",
        gender
          :
          "",
        first_name
          :
          data.default_death_beneficiary[i]?.person?.last_name ,

        national_code
          :
          data.default_death_beneficiary[i]?.person?.national_code ,
        percent
          :
          data.default_death_beneficiary[i]?.percent?.percent_id,
        priority
          :
          "1",
        relation_id
          :
          data.default_death_beneficiary[i]?.relation?.relation_id,
      
    }
    defaultDeath_bens.push(obj);
  }
  this.setState({ death_bens: defaultDeath_bens })

  
  const defaultLife_bens = []
  for (var i = 0; i <  data.default_life_beneficiary?.length; i++) { 
    const obj = {
      

        birthday
          :
         "",

         last_name
          :
          "",
        fatherName
          :
          "",
        gender
          :
          "",
          first_name
          :
          data.default_life_beneficiary[i]?.person?.last_name ,

        national_code
          :
          data.default_life_beneficiary[i]?.person?.national_code ,
        percent
          :
          data.default_life_beneficiary[i]?.percent?.percent_id,
        priority
          :
          "1",
        relation_id:
          data.default_life_beneficiary[i]?.relation?.relation_id,
      
    }
    defaultLife_bens.push(obj);
  }
  this.setState({ life_bens: defaultLife_bens })

     
      
    }else{
      this.setState({ sharesList : data[0]?.values }) 
      
    }
    }
  } catch (error) {
    console.error(error);
  }
};
checkRelationAndPercent = () => {
  const { isLife , life_bens , death_bens } = this.state;

  const list = isLife ? life_bens : death_bens;

  const hasRelation68AndPercent101 = list?.some(
    (item:any) => Number(item.relation_id) === 68 && Number(item.percent) === 101
  );
  const hasPercent102 = list?.some((item:any) => Number(item.percent) === 102);

  if (hasRelation68AndPercent101 && !hasPercent102) {                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   
    return true;
  }
  return false;
};


getDefaultIssuing = async (isEdit?:boolean) => {
    this.setState({ contentLoading: true })
    try {
      const contractId = window.location.pathname.split("/")[2];
      let response;
  
      if (contractId) {
        response = await service.limitationInquiry.issuingDefault(contractId);
        if (response) {
          this.setState({ contentLoading: false })
        const  defaults = response.data.data.data;
        
        this.getCityList(defaults?.insured_province_id, true )
        this.getCityList(defaults?.policy_holder_province_id,false)

         this.setState({
           // return response;
           insured_national_code: defaults?.insured_national_code ,
           policy_holder_national_code: defaults?.policy_holder_national_code ,
           new_policy_holder: defaults?.new_policy_holder ,
           is_withdrawal_from_savings: defaults?.is_withdrawal_from_savings ,
           insured_is_married:defaults?.insured_is_married ,
           policy_holder_is_married:defaults?.policy_holder_is_married ,
           insured_mobile:defaults?.insured_mobile ,
           policy_holder_mobile:defaults?.insured_mobile  ,
           insured_weight:defaults?.insured_weight ,
          policy_holder_weight : defaults?.policy_holder_weight  ,
          insured_height: defaults?.insured_height  ,
          policy_holder_height: defaults?.policy_holder_height  ,
          insured_city_id: defaults?.insured_city_id  ,
          policy_holder_city_id: defaults?.policy_holder_city_id  ,
          insured_province_id: defaults?.insured_province_id  ,
          policy_holder_province_id: defaults?.policy_holder_province_id  ,
          insured_postal_code: defaults?.insured_postal_code  ,
          policy_holder_postal_code: defaults?.policy_holder_postal_code  ,
          insured_address: defaults?.insured_address  ,
          policy_holder_address: defaults?.policy_holder_address  ,
          // life_bens:defaults?.life_bens || "" ,
          // death_bens:defaults?.death_bens || "" ,
          disease_policy_holder: defaults?.policy_holder_questions[0]?.disease_policy_holder,
          public_policy_holder: defaults?.policy_holder_questions[0]?.public_policy_holder,
          relation_with_policy_holder:Number(defaults?.relation_with_policy_holder),
          disease_insured: defaults?.insured_questions[0]?.disease_insured,
          public_insured: defaults?.insured_questions[0]?.public_insured
         })
         
         const lifeBensInfo = []
         for (var i = 0; i < defaults?.life_bens?.length; i++) { 
          const obj = {
      

            birthday
                :
                "",

               last_name
                :
                "",
              fatherName
                :
                "",
              gender
                :
                "",
              first_name
                :
                defaults?.life_bens[i]?.last_name ,
      
              national_code
                :
                defaults?.life_bens[i]?.national_code ,
              percent
                :
                defaults?.life_bens[i]?.percent,
              priority
                :
                "1",
              relation_id
                :
                defaults?.life_bens[i]?.relation_id,
            
          }
          lifeBensInfo.push(obj);
        }
        this.setState({ life_bens: lifeBensInfo })

        // /

        const deathBensInfo = []
        for (var i = 0; i < defaults?.death_bens?.length; i++) { 
         const obj = {
     

          birthday
               :
               "",
     
              last_name
               :
               "",
             fatherName
               :
               "",
             gender
               :
               "",
             first_name
               :
               defaults?.death_bens[i]?.last_name ,
     
             national_code
               :
               defaults?.death_bens[i]?.national_code ,
             percent
               :
               defaults?.death_bens[i]?.percent,
             priority
               :
               "1",
             relation_id
               :
               defaults?.death_bens[i]?.relation_id,
           
         }
         deathBensInfo.push(obj);
       }
       this.setState({ death_bens: deathBensInfo }) 
     }
    
     
 }

    } catch (error:any) {
      this.setState({ contentLoading: false })
      if(error?.status === 400){
        toast.error("قرارداد یافت نشد")
      }
      // throw error;
    }
  };

  nextStep = () => {
    const { step } = this.state;
    const { inqueryData } = this.props;
    const shouldSkipQuestions = inqueryData?.start_death_asset <= inqueryData?.minimum_insurance_premium;

    if (step === 4 && shouldSkipQuestions) {
      this.setState({ openConfirmationInformationModal: true })
          } else if (step < 7) {
        this.setState({ step: step + 1 });
    }
}

}
export default IssuingController;